import React from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";

import { useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faIdCard,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";

import "./Header.css";

const Header = () => {
  const isLoggedIn = useSelector((state) => state.authentication.loggedIn);
  // const currentUser = useSelector((state) => state.authentication.user);
  const isAccountPrimaryUser = true;
  const isAdmin = false;
  // const isStylist = true;

  // status boxe on the navigation panel
  // const loginBox = (
  //   <span className="navbar-info">
  //     Signed in as:{" "}
  //     {/* <a href={"/profile/" + currentUser ? currentUser.account_id : ""}> */}
  //     <a href="/profile/">
  //       {currentUser && currentUser.name ? currentUser.name : "unknown"}
  //     </a>
  //   </span>
  // );
  // const welcomeBox = (
  //   <span className="navbar-info">
  //     <a href="/login">Login&nbsp;</a>/<a href="/register">&nbsp;Register</a>
  //   </span>
  // );

  // navigation panel menu items
  const homeMenuItem = <Nav.Link href="/">Home</Nav.Link>;
  const aboutMenuItem = <Nav.Link href="/about">About</Nav.Link>;
  // const priceMenuItem = <Nav.Link href="/price">Price</Nav.Link>;
  // const servicesMenuItem = <Nav.Link href="/services">Services</Nav.Link>;
  const portfolioMenuItem = <Nav.Link href="/portfolio">Portfolio</Nav.Link>;
  const certificatesMenuItem = <Nav.Link href="/certificates">Certificates</Nav.Link>;
  // const contactInfoMenuItem = <Nav.Link href="/contact">Contact</Nav.Link>;

  // const stylistsMenuItem = <Nav.Link href="/stylists">Stylists</Nav.Link>;

  // const servicesMenuItem = <Nav.Link href="/services">Services</Nav.Link>;
  // const portfolioMenuItem = <Nav.Link href="/portfolio">Portfolio</Nav.Link>;
  // const scheduleMenuItem = <Nav.Link href="/schedule">Schedule</Nav.Link>;

  // const clientsMemuItem = <Nav.Link href="/clients">Clients</Nav.Link>;
  const usersMenuItem = <Nav.Link href="/users">Users</Nav.Link>;
  const accountsMenuItem = <Nav.Link href="/accounts">Accounts</Nav.Link>;

  const accountDropdownMenuItem = () => {
    return (
      <NavDropdown title="Account" id="app-nav-dropdown">
        <NavDropdown.Item href="/change-password">
          <FontAwesomeIcon icon={faLock} /> Change Password
        </NavDropdown.Item>
        <NavDropdown.Item href="/profile">
          <FontAwesomeIcon icon={faIdCard} /> Profile
        </NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.Item href="/login">
          <FontAwesomeIcon icon={faSignOutAlt} /> Logout
        </NavDropdown.Item>
      </NavDropdown>
    );
  };

  return (
    <div className="header d-flex">
      <Navbar
        // className="navbar-transparent header-navbar fixed-top"
        className="header-navbar fixed-top"
        color-on-scroll="300"
        bg="secondary"
        variant="dark"
        expand="lg"
      >
        <Navbar.Brand href="/">
          <Navbar.Text>
            <img className="logo" src="/lana_hill_logo.png" alt="logo"/>
          </Navbar.Text>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="app-navbar-nav" />
        <Navbar.Collapse id="app-navbar-nav">
          <Nav className="mr-auto">
            {homeMenuItem}
            {aboutMenuItem}
            {/* {priceMenuItem} */}
            {/* {servicesMenuItem} */}
            {portfolioMenuItem}
            {certificatesMenuItem}
            {/*{contactInfoMenuItem}*/}
          </Nav>
        </Navbar.Collapse>
        <Navbar.Collapse className="justify-content-end">
          <Nav>
            {/* {isStylistSelected || isStylist ? null : stylistsMenuItem} */}
            {/* {isLoggedIn && (isStylist || isStylistSelected)
              ? servicesMenuItem
              : null}
            {isLoggedIn && (isStylist || isStylistSelected)
              ? portfolioMenuItem
              : null}
            {isLoggedIn && (isStylist || isStylistSelected)
              ? scheduleMenuItem
              : null} */}
            {/*{isLoggedIn && isStylist ? clientsMemuItem : null}*/}
            {isLoggedIn && isAccountPrimaryUser ? usersMenuItem : null}
            {isLoggedIn && isAdmin ? accountsMenuItem : null}
            {isLoggedIn ? accountDropdownMenuItem() : null}
          </Nav>
          <Navbar.Text className="status-text">
             {/*{isLoggedIn ? loginBox : welcomeBox}*/}
          </Navbar.Text>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default Header;
